import { Resellers } from "modules/resellers";

const ResellersPage = () => {
  return <Resellers />;
};

export default ResellersPage;
